import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BackendApiService } from './services/backend-api.service';
import { LightchartComponent } from './lightchart/lightchart.component';
import { BackendSocketService } from './services/backend-socket.service';
import { BadlamarketComponent } from './badlamarket/badlamarket.component';
import { FooterComponent } from './footer/footer.component';
import { BadlaorderComponent } from './badlaorder/badlaorder.component';

import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';

import { OnlynumberDirective } from './auth-gaurd/onlynumber.directive';
import {ToasterModule} from 'angular2-toaster';
import { EndbadlaorderComponent } from './endbadlaorder/endbadlaorder.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UnauthpageComponent } from './unauthpage/unauthpage.component';
import {AuthGuard} from "./auth-gaurd/auth-guard.service";
import { LivebadlaComponent } from './livebadla/livebadla.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { BadlaorderdetailComponent } from './badlaorderdetail/badlaorderdetail.component';
import { SettlementoldComponent } from './settlementold/settlementold.component';
import { DataTablesModule } from 'angular-datatables';
import { HistoryComponent } from './history/history.component';
import { OldbadlaComponent } from './oldbadla/oldbadla.component';


@NgModule({
  declarations: [
    AppComponent,
    LightchartComponent,
    BadlamarketComponent,
    FooterComponent,
    BadlaorderComponent,
    BadlaorderdetailComponent,
    OnlynumberDirective,
    EndbadlaorderComponent,
    UnauthpageComponent,
    LivebadlaComponent,
    LoginComponent,
    HeaderComponent,
    SettlementoldComponent,
    HistoryComponent,
    OldbadlaComponent,
  ],
  imports: [
    NgbModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    ToasterModule.forRoot(),
    NgxSpinnerModule,
    DataTablesModule
  ],
  providers: [BackendApiService,BackendSocketService,BsModalService,AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
